<template>
    <Modal
        modal-name="modal-prebasket"
        modal-class="modal-prebasket"
        size="xl"
        :title="$t('prebasket.title')"
        :render-to-initial-html="true"
        @close="closePrebasket()"
    >
        <div v-if="product" class="between-cart__product-center pe-md-3" :data-product-id="product.id">
            <div class="image bg-grey-light rounded p-2">
                <a :href="product.url" class="d-block text-center" @click="triggerSelectItemEvent">
                    <img
                        v-lazy-load
                        src="/nuxt-assets/images/lazy-load-error.svg"
                        :data-src="product.image"
                        :alt="product.name"
                        class="img-fluid lazyload"
                    />
                </a>
                <div v-if="product.percentDiscount" class="discount">-{{ product.percentDiscount }} %</div>
            </div>

            <div>
                <div class="between-cart__product-center--right">
                    <div>
                        <a
                            :href="product.url"
                            class="text-truncate-2 text-black d-block fwb fs-14 fs-md-15"
                            @click="triggerSelectItemEvent"
                        >
                            {{ product.name }}
                        </a>
                        <span class="between-cart__addBasket mt-2 col-md-3">
                            <ElementsButtonAddBasket
                                :add-basket-align="``"
                                :button-class="`btn-outline-primary btn-sm add-cart__simple`"
                                :product="productAsProduct"
                                :product-id="product.id"
                                :product-price="product.price"
                                :is-preorder="product.isPreorder"
                                :max-amount-per-order="product.attributes.maxAmountPerOrder"
                                :has-substitution-modal="product.substitutions?.isModal || false"
                                :item-list-name="mainItemListName"
                                class="mt-1"
                            />
                            <div class="pt-md-0 text-right d-md-none">
                                <s
                                    v-if="product.priceBeforeDiscount"
                                    class="old me-1 notranslate"
                                    v-html="$formatCurrency(product.priceBeforeDiscount)"
                                ></s>
                                <span
                                    class="fs-16 d-block fwb text-primary text-nowrap notranslate"
                                    v-html="$formatCurrency(actualUnitPrice)"
                                ></span>
                            </div>
                        </span>
                    </div>

                    <div class="pt-2 pt-md-0 text-right d-none d-md-block">
                        <s
                            v-if="product.priceBeforeDiscount"
                            class="old me-1 notranslate"
                            v-html="$formatCurrency(product.priceBeforeDiscount)"
                        >
                        </s>
                        <span class="fs-16 d-block fwb text-primary text-nowrap notranslate" v-html="$formatCurrency(actualUnitPrice)">
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <QuantityDiscount v-if="product" :quantity-groups="product.amountPrices || []" :product="product" />

        <!--<BuyNGetOneFree v-if="hasOfferBuyNGetOneFree"
                                 :is-success="buyGetFreeOfferMinQuantity <= productAmounts"
                                 :title="buyGetFreeOfferTitle"
                                 :quantity="productAmounts"
                                 :min-quantity="buyGetFreeOfferMinQuantity"
                                 @click-button="addToBasket(buyGetFreeOfferMinQuantity)" />-->
        <div v-if="cartData.voucherErrorMessage?.length" class="voucher-error-message">
            {{ cartData.voucherErrorMessage }}
        </div>
        <div class="row align-items-center mb-4">
            <div class="col-12 col-sm-6 text-md-left order-2 order-md-1 pt-3 pt-md-0">
                <a href="#" class="btn btn-outline-primary mb-3 mb-md-0 d-block d-sm-inline-block px-4" @click.prevent="closePrebasket">
                    {{ $t('prebasket.continue') }}
                </a>
            </div>

            <div class="col-12 col-sm-6 text-right order-1 order-md-2">
                <nuxt-link :to="$t('links.basket')" class="btn btn-primary px-3 d-block d-sm-inline-block fwb px-4">
                    {{ $t('prebasket.tocart') }}
                </nuxt-link>
            </div>
        </div>
        <!--        <LayoutCartDeliveryPriceProgress />-->
        <div v-if="banner" class="text-center mt-2 mt-3 mt-md-3 mb-4">
            <a :href="banner.url" @click="closePrebasket">
                <img
                    v-lazy-load
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="banner.desktopImage"
                    :alt="banner.title"
                    class="img-fluid w-100 d-none d-md-block"
                />

                <img
                    v-lazy-load
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="banner.mobileImage"
                    :alt="banner.title"
                    class="img-fluid w-100 d-md-none"
                />
            </a>
        </div>

        <template v-if="product && product.giftActions?.length">
            <objectsPreBasketGiftActions
                v-for="giftAction in product.giftActions"
                :key="giftAction.giftEventId"
                :gift-action="giftAction"
            />
        </template>

        <!--        <div v-if="preBasketAbTestVariant === 0" id="zoe-cart-popup" :data-id="product.id"></div>-->

        <!--        <CarouselById-->
        <!--            v-else-if="-->
        <!--                (preBasketAbTestVariant === 1 || preBasketAbTestVariant === null) &&-->
        <!--                product.attributes &&-->
        <!--                product.attributes.machineLearningAddOnProducts-->
        <!--            "-->
        <!--            :ids="product.attributes.machineLearningAddOnProducts"-->
        <!--            :title="$t('prebasket.notAddOnProducts')"-->
        <!--            :show-pre-basket="false"-->
        <!--            type-item="slim-carousel__item&#45;&#45;prebasket"-->
        <!--            :products-in-skeleton="4"-->
        <!--            :item-list-name="addonSaleItemListName"-->
        <!--            :available-only="true"-->
        <!--        />-->

        <!--        preBasketAbTestVariant === 2 &&-->
        <CarouselById
            v-if="product && notAddonProductIds.length"
            :ids="notAddonProductIds"
            :title="$t('prebasket.notAddOnProducts')"
            :show-pre-basket="false"
            type-item="slim-carousel__item--prebasket"
            :products-in-skeleton="4"
            :item-list-name="addonSaleItemListName"
            :available-only="true"
            :in-stock-only="true"
            :luigis-box-carousel-type="getLuigisBoxCarouselType('RecoBasketPopUpAbTest') || 'prebasket'"
            :is-luigis-box-variant="isLuigisBoxCarouselVariant('RecoBasketPopUpAbTest')"
            :luigis-box-carousel-title="product.url"
            :luigis-box-item-ids="product.url"
        />

        <SkeletonProductCarouselSkeleton v-if="customAddonSaleCarouselsAreLoading" :max-number-of-products="4" />
        <template
            v-if="
                product &&
                !customAddonSaleCarouselsAreLoading &&
                customAddonSaleCarousels &&
                Object.keys(customAddonSaleCarousels).length !== 0
            "
        >
            <CarouselBox
                v-for="(carousel, index) in customAddonSaleCarousels"
                :key="index"
                :title="carousel.title"
                :products="carousel.products"
                :show-pre-basket="false"
                class="carouselBox--preBasket"
                type-item="slim-carousel__item--prebasket"
                :item-list-name="customAddonSaleCarouselsItemListName"
                luigis-box-carousel-type="prebasket"
                :luigis-box-carousel-title="product.url"
                :luigis-box-item-ids="product.url"
            />
        </template>

        <SkeletonProductCarouselSkeleton v-if="addonSaleAreasAreLoading" :max-number-of-products="4" />
        <template v-if="product && !addonSaleAreasAreLoading && addonSaleAreas && Object.keys(addonSaleAreas).length !== 0">
            <CarouselBox
                v-for="(carousel, index) in addonSaleAreas"
                :key="index"
                :title="carousel.title"
                :products="carousel.products"
                :show-pre-basket="false"
                class="carouselBox--preBasket"
                type-item="slim-carousel__item--prebasket"
                :item-list-name="addonSaleAreasItemListName"
                luigis-box-carousel-type="prebasket"
                :luigis-box-carousel-title="product.url"
                :luigis-box-item-ids="product.url"
            />
        </template>
    </Modal>
</template>

<script lang="ts">
import CarouselBox from '~/components/elements/CarouselBox.vue'
import CarouselById from '~/components/elements/CarouselById.vue'
import Modal from '~/components/Modal.vue'
import { useBasketStore } from '~/stores/basket'
import { useLayoutStore } from '~/stores/layout'
import { usePreBasketStore } from '~/stores/preBasket'
import { GtmEcommerceEventTypeEnum } from '~/models/DataLayer/GtmEcommerceEventTypeEnum'
import GtmEcommerceEvent from '~/models/DataLayer/GtmEcommerceEvent'
import DataLayer from '~/extensions/DataLayer'
import { useAbTestStore } from '~/stores/abTest'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import { transformProductToGtmProduct } from '~/utils/transformProductToGtmProduct'
import QuantityDiscount from '~/components/elements/QuantityDiscount.vue'
import FullProduct from '~/models/Product/FullProduct'
import Product from '~/models/Product/Product'
import LuigisRecoTypes from '~/value/LuigisRecoTypes'
import { useCookie } from '#imports'

export default {
    components: {
        QuantityDiscount,
        CarouselBox,
        CarouselById,
        Modal,
    },

    provide() {
        return {
            productIdReferrer: computed(() => this.product?.id),
        }
    },

    data() {
        return {
            loading: true,
            product: null as FullProduct | null,
            buyGetFreeOfferMinQuantity: null,
            buyGetFreeOfferTitle: '',
            notAddonProductIds: [] as number[],
        }
    },

    computed: {
        productAsProduct(): Product {
            return this.product as Product
        },

        actualUnitPrice() {
            const basketStore = useBasketStore()

            if (basketStore.productUnitPrices[this.product.id]) {
                return basketStore.productUnitPrices[this.product.id].price
            }

            return this.product.price
        },

        mainItemListName(): string {
            return GtmItemListNameEnum.PrebasketMain
        },

        addonSaleItemListName(): string {
            return GtmItemListNameEnum.PrebasketAddonSale
        },

        customAddonSaleCarouselsItemListName(): string {
            return GtmItemListNameEnum.PrebasketCustomAddonSaleCarousels
        },

        addonSaleAreasItemListName(): string {
            return GtmItemListNameEnum.PrebasketAddonSaleAreas
        },

        preBasketAbTestVariant(): number | null {
            const abTestStore = useAbTestStore()

            return abTestStore.getVariant('PreBasketAbTest')
        },

        cartData() {
            return useBasketStore()
        },

        banner() {
            const layoutStore = useLayoutStore()

            return layoutStore.upsellPopupBanner
        },

        productAmounts() {
            const basketStore = useBasketStore()

            return basketStore.productAmounts[this.product.id]
        },

        customAddonSaleCarousels() {
            const basketStore = useBasketStore()

            return basketStore.customAddonSaleCarousels || null
        },

        customAddonSaleCarouselsAreLoading() {
            const basketStore = useBasketStore()

            return basketStore.customAddonSaleCarouselsAreLoading
        },

        addonSaleAreas() {
            const basketStore = useBasketStore()

            return basketStore.addonSaleAreas || null
        },

        addonSaleAreasAreLoading() {
            const basketStore = useBasketStore()

            return basketStore.addonSaleAreasAreLoading
        },

        // Product has offer - 1+1. 2+1, 3+1
        /* hasOfferBuyNGetOneFree() {
             const action = this.product?.giftActions?.find((action) => action.percentageDiscountGiftMinAmount)

             if (action) {
                this.buyGetFreeOfferMinQuantity = action.percentageDiscountGiftMinAmount
                this.buyGetFreeOfferTitle = action.title
                return true
            } else {
                return false
            }
        }, */
    },

    mounted() {
        useNuxtApp().$bus.$off('show-prebasket')
        useNuxtApp().$bus.$on('show-prebasket', async (product: FullProduct) => {
            this.product = product
            this.productIdReferrer = product.id
            usePreBasketStore().setProductIdReferrer(product.id)

            if (useAbTestStore().getVariant('RecoBasketPopUpAbTest') === 0) {
                const response = await this.$repository.getRecoProducts(
                    LuigisRecoTypes.BASKET_POPUP,
                    product.id,
                    useUidCookie().value,
                    useCookie('_lb').value ?? ''
                )
                this.notAddonProductIds = response.products.map((product: Product) => product.id)
            } else {
                this.notAddonProductIds = product.attributes.machineLearningAddOnProducts.filter(
                    (productId: number) => productId !== product.id
                )
            }
        })
    },

    methods: {
        getLuigisBoxCarouselType(testName: string) {
            if (!this.isLuigisBoxCarouselVariant(testName)) {
                return null
            }

            if (testName === 'RecoBasketPopUpAbTest') {
                return LuigisRecoTypes.BASKET_POPUP
            }

            return null
        },

        isLuigisBoxCarouselVariant(testName: string) {
            return useAbTestStore().getVariant(testName) === 0
        },

        addToBasket(amount: number) {
            const basketStore = useBasketStore()
            basketStore.changeAmount(this.product.id, amount)
        },

        triggerSelectItemEvent() {
            const ecommerceEvent = {
                type: GtmEcommerceEventTypeEnum.ClickToProductDetail,
                products: [transformProductToGtmProduct(this.product)],
                itemListName: GtmItemListNameEnum.PrebasketAddonSale,
                productIdReferrer: this.productIdReferrer,
            } as GtmEcommerceEvent

            DataLayer.pushEcommerceEventToDataLayer(ecommerceEvent)
        },

        closePrebasket() {
            useNuxtApp().$bus.$emit('hideModal')

            usePreBasketStore().clearProductIdReferrer()
        },
    },
}
</script>
<style lang="scss">
.modal-prebasket {
    @media (max-width: 768px) {
        .modal-body {
            height: auto !important;
        }
    }
}
</style>
<style lang="scss" scoped>
.between-cart .add-cart__simple {
    padding: 3px 20px 5px;
}

.between-cart {
    &__addBasket {
        display: flex;
        justify-content: space-between;

        :deep(.add-cart) {
            @media (max-width: $screen-md) {
                width: auto;
            }
        }
    }

    &__free-shipping {
        background-color: #ecf4d9;
        color: $color-green-dark;
        border-radius: 50px;

        img {
            margin-top: -4px;
        }
    }

    &__product-center {
        margin: 0 auto;
        display: grid;
        grid-template-columns: 75px auto;
        align-items: center;
        grid-column-gap: 20px;
        padding-bottom: 13px;

        .image {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 75px;
            height: 75px;
            position: relative;

            .discount {
                position: absolute;
                right: -15px;
                top: -15px;
                width: 40px;
                height: 40px;
                min-width: 40px;
            }
        }

        img {
            max-height: 50px;
        }

        &--right {
            display: grid;
            align-items: self-end;

            @media (min-width: $screen-md) {
                grid-template-columns: auto 160px;
            }
        }
    }

    &__product {
        &--img {
            display: block;
            width: 100%;
            height: 130px;
        }

        &--title {
            height: 37px;
        }

        // @todo refactoring, nereflektuje BEM
        &--order-popup {
            height: 50px;
        }
    }
}

.voucher-error-message {
    padding: 1.5rem;
    border-radius: $rounded;
    text-align: center;
    margin-bottom: 1.5rem;

    background: $color-alert-light;
    color: $color-alert;
}
</style>
